import { render, staticRenderFns } from "./PiePlayer.vue?vue&type=template&id=7b33a6cb"
import script from "./PiePlayer.vue?vue&type=script&lang=ts"
export * from "./PiePlayer.vue?vue&type=script&lang=ts"
import style0 from "./PiePlayer.vue?vue&type=style&index=0&id=7b33a6cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports